import { useEffect } from 'react';
import { usePrevious } from 'hooks';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import StorageService from 'services/StorageService';

const ScrollTop = (props) => {

    useEffect(() => {
        changePage(true);
    },[]);

    const prevProps = usePrevious(props);

    useEffect(() => {
        if ((prevProps && (props.location.pathname !== prevProps.location.pathname)) || (prevProps && (props.location.search !== prevProps.location.search)) && (props.location.search.indexOf('?q=') === -1 || props.location.search.indexOf('&q=') === -1 ) && (props.location.pathname.indexOf('institucional') === -1 )){

            changePage();
        }
    },[props.location]);

    const changePage = (init = false)=> {

        const redirectGtm = StorageService.getItem("GTMRedirect");
        const redirectInfo = redirectGtm ? JSON.parse(redirectGtm): '';

        if (redirectInfo &&  props.location && !(props.location.pathname.includes(redirectInfo.tag)) ){
            StorageService.removeItem("GTMRedirect");
        }
        
        if(!init && window){
            window.scrollTo(0, 0);
        }

    }

    return props.children;
    
}

ScrollTop.propTypes = {
    location: PropTypes.object,
    children: PropTypes.array
};

export default withRouter(ScrollTop);
